import script from "./AdmissionNote.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmissionNote.vue?vue&type=script&setup=true&lang=js"

import "./AdmissionNote.vue?vue&type=style&index=0&id=541f060c&lang=css"

const __exports__ = script;

export default __exports__